import { Component, Inject, ViewContainerRef, ComponentFactoryResolver, AfterViewInit, ViewChild, Input, ChangeDetectorRef, OnInit, Output, EventEmitter, Type, OnDestroy } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Subject } from 'rxjs';

@Component({
    selector: 'bciti-confirm-dialog',
    templateUrl: './bciti-confirm-dialog.component.html',
    styleUrls: ['./bciti-confirm-dialog.component.scss'],
})
export class BcitiConfirmDialogComponent implements OnInit, AfterViewInit, OnDestroy {
    destroy$ = new Subject();
    @ViewChild('componentVisual', { read: ViewContainerRef }) vc: ViewContainerRef;

    public title: string;
    public titleClass: string;
    public body: string;
    public bodyClass: string;
    public icon: string;
    public iconColor: string;
    public confirmLabel: string;
    public cancelLabel: string;
    public confirmButtonClass: string;
    public cancelButtonClass: string;
    public hideActionButtons: boolean;
    public loading = false;

    @Output() onSubmit: EventEmitter<any> = new EventEmitter<any>();

    constructor(
        private cd: ChangeDetectorRef,
        private componentFactoryResolver: ComponentFactoryResolver,
        public dialogRef: MatDialogRef<BcitiConfirmDialogComponent>,
        @Inject(MAT_DIALOG_DATA)
        public data: {
            dialog: {
                title?: string;
                titleClass?: string;
                body?: string;
                bodyClass?: string;
                icon?: string;
                iconColor?: string;
                confirmLabel?: string;
                cancelLabel?: string;
                confirmButtonClass?: string;
                cancelButtonClass?: string;
                hideActionButtons?: boolean;
                loading?: boolean;
            };
            component: {
                data: {
                    [key: string]: any;
                };
                entry: Type<unknown>;
            };
        },
    ) {}

    ngOnInit() {
        this.title = this.data.dialog.title;
        this.titleClass = this.data.dialog.titleClass;
        this.body = this.data.dialog.body;
        this.bodyClass = this.data.dialog.bodyClass;
        this.icon = this.data.dialog.icon;
        this.iconColor = this.data.dialog.iconColor;
        this.confirmLabel = this.data.dialog.confirmLabel;
        this.cancelLabel = this.data.dialog.cancelLabel;
        this.confirmButtonClass = this.data.dialog.confirmButtonClass;
        this.cancelButtonClass = this.data.dialog.cancelButtonClass;
        this.hideActionButtons = this.data.dialog.hideActionButtons;
        this.loading = this.data.dialog.loading ?? false;
    }

    ngAfterViewInit() {
        this.loadComponent();
    }

    loadComponent() {
        this.vc.clear();
        if (this.data.component.entry) {
            const componentFactory = this.componentFactoryResolver.resolveComponentFactory(this.data.component.entry);
            const componentRef = this.vc.createComponent(componentFactory);
            // Overwrite component properties with data passed through the data object in dialogRef.open
            // See admin-notification-list.component.ts for usage example
            for (const key of Object.keys(this.data.component.data)) {
                componentRef.instance[`${key}`] = this.data.component.data[`${key}`];
            }
            componentRef.changeDetectorRef.detectChanges();
        }
    }

    onNoClick(): void {
        this.cancel();
    }

    close(): void {
        this.dialogRef.close();
    }

    confirm(): void {
        this.onSubmit.emit(true);
        // Two supported usage patterns:
        //  - onSubmit + loading: consumers subscribe to `onSubmit`, set `loading = true`
        //    synchronously above to keep the dialog open during an async action, and close it
        //    themselves. Detect that here and leave it open.
        //  - afterClosed: consumers rely on the dialog closing with the result. Close with `true`
        //    so `dialogRef.afterClosed()` emits a truthy value (otherwise confirm does nothing).
        if (!this.loading) {
            this.dialogRef.close(true);
        }
    }

    cancel(): void {
        this.onSubmit.emit(false);
        this.close();
    }

    ngOnDestroy(): void {
        this.destroy$.next();
        this.destroy$.complete();
    }
}
